import ecobag from '../assets/totebag_bookster.webp'
import passaporte from '../assets/Passaporte_literario.webp'

export const BRINDES = [
  {
    'id': 'ecobag',
    'nome': 'Ecobag exclusiva',
    'imagem': ecobag,
    'alt': 'Ecobag de lona com a estampa Lendo o mundo'
  },
  {
    'id': 'passaporte',
    'nome': 'Passaporte literário',
    'imagem': passaporte,
    'alt': 'Passaporte literário do clube, com a capa "Leituras em progresso"',
    'disponivelNaReativacao': false
  }
]

export function brindesDisponiveis( { contextoReativacao } ) {
  return BRINDES.filter( ( brinde ) => !contextoReativacao || brinde.disponivelNaReativacao !== false )
}
